<template>
  <div class="block">
    <kst-number-with-date input-mode
      :catalog="Catalog"
      :data="userData"
      autoNumberField="IsAutoNumber"
      dateField="Date"
      numberField="ReturnNumber"
    />

    <template v-if="userData.VendorID">
      <kst-output control-off field="VendorID" :data="userData" :catalog="Catalog">
        <template #left>
          <kst-output addons floating-label
            field="VendorAlias" :data="userData" :catalog="Catalog"
          />
        </template>
        <template #default>
          <kst-output addons expanded floating-label
            field="VendorName" :data="userData" :catalog="Catalog"
          />
        </template>
      </kst-output>
    </template>
    <template v-else>
      <kst-output control-off field="VendorID" :data="userData" :catalog="Catalog">
        <kst-output addons expanded floating-label
          field="VendorName" :data="userData" :catalog="Catalog"
        />
      </kst-output>
    </template>

    <kst-output field="VendorAddress" :data="userData" :catalog="Catalog"/>

    <kst-input field="WarehouseID" :data="userData" :catalog="Catalog"
      :options="warehouseOptions"
    />

    <kst-input field="Comment" :data="userData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../RrcvCatalog.js";

export default {
  props: {
    userData: Object,
    warehouseOptions: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>